import axios from 'axios';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { ButtonGroup, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { signOut } from '../../../actions/auth.actions';
import Button from '../../../shared/components/Button';
import FormControl from '../../../shared/components/Form/FormControl';
import DeactivateSidePane from './DeactivateSidePane/DeactivateSidePane';

const Settings = ({ signOut }) => {
  const [state, setState] = useState({
    loading: false,
    success: false,
    isPaneOpen: false,
  });
  const { t } = useTranslation();

  const validationSchema = Yup.object({
    password: Yup.string()
      .min(8, `${t('influencers.common.must_be_or_more', { num: 8 })}`)
      .required(`${t('influencers.common.forms.is_required')}`),
    passwordConfirmation: Yup.string()
      .min(8, `${t('influencers.common.must_be_or_more', { num: 8 })}`)
      .required(`${t('influencers.common.forms.is_required')}`)
  });

  const formik = useFormik({
    initialValues: {
      currentPassword: '',
      password: '',
      passwordConfirmation: '',
    },
    validationSchema,
    onSubmit: values => {
      setState({ loading: true });
      axios.put('/api/v1/influencers/users/password', {
        user: {
          current_password: values.currentPassword,
          password: values.password,
          password_confirmation: values.passwordConfirmation,
        }
      }).then(({ data }) => {
        if (data.success) {
          setState({ ...state, success: true });
          signOut();
        } else { throw 'Something went wrong!'; }
      }).catch(() => {
        setState({ ...state, success: false, loading: false });
      });
    },
  });

  return (
    <React.Fragment>
      <Form className='mb-6' onSubmit={formik.handleSubmit}>
        <Container >
          <h3 className='mb-4'>{t('influencers.pages.settings.title')}</h3>
          <Row>
            <Col xs={12} sm={4}>
              <Form.Group>
                <Form.Label>{t('influencers.pages.settings.old_password')}</Form.Label>
                <FormControl
                  id='currentPassword'
                  type="password"
                  placeholder={`${t('influencers.common.password')}...`}
                  {...formik.getFieldProps('currentPassword')}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={4}>
              <Form.Group>
                <Form.Label>{t('influencers.pages.settings.new_password')}</Form.Label>
                <FormControl
                  id='password'
                  type="password"
                  placeholder={`${t('influencers.common.password')}...`}
                  {...formik.getFieldProps('password')}
                />
                <Form.Text className="text-muted danger-text">
                  {formik.touched.password && formik.errors.password}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={4}>
              <Form.Group>
                <Form.Label>{t('influencers.pages.settings.confirm_new_password')}</Form.Label>
                <FormControl
                  id='passwordConfirmation'
                  type="password"
                  placeholder={`${t('influencers.common.password')}...`}
                  {...formik.getFieldProps('passwordConfirmation')}
                />
                <Form.Text className="text-muted danger-text">
                  {formik.touched.passwordConfirmation &&  formik.errors.passwordConfirmation}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <div className="text-3">{t('influencers.pages.settings.password_policies')}</div>
          <div className="text-3">{t('influencers.pages.settings.recommended_password_length')}</div>
          <div className="text-3">{t('influencers.pages.settings.recommended_password_characters')}</div>
        </Container>

        <hr className='my-6' />

        <Container>
          <Row className='justify-content-end'>
            <Col xs="auto">
              <ButtonGroup>
                <Button
                  className="pr-0"
                  variant="tertiary"
                  onClick={() => setState({ isPaneOpen: true })}
                >
                  <span className="text-underline">
                    {t('influencers.pages.settings.deactivate_account')}
                  </span>
                </Button>
                <div className="btn-gradient align-self-end">
                  <div className="background-gradient"></div>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    disabled={state.loading}
                    onClick={() => formik.resetForm()}
                  >
                    {t('influencers.common.cancel')}
                  </button>
                </div>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={ state.loading || !formik.dirty || !formik.isValid }
                >
                  {state.loading ?
                    <Spinner animation="border" size="sm" /> :
                    t('influencers.common.save_changes')
                  }
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        </Container>
      </Form>
      <DeactivateSidePane
        isPaneOpen={state.isPaneOpen}
        onRequestClose={() => setState({ isPaneOpen: false })}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({ auth: state.auth });
const mapDispatchToProps = (dispatch) => ({
  signOut: () => signOut(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);

